import React from 'react'
import './primaryLoader.css'

const PrimaryLoader = ({color}) => {
  return (
    <span class="loader"></span>
  )
}

export default PrimaryLoader